import {useMemo} from 'react';
import {getFAQsByStrategy} from '../utils/faqStrategy';
import type {FAQ} from '../utils/faqConfig';

export const useFAQs = (): FAQ[] => {
  return useMemo(() => getFAQsByStrategy(), []);
};
